var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getShortcutAttrs, TextShortcut } from './shortcut-plugin';
var textMarkShortcut = function (regexp, name, config) {
    return new TextShortcut(name, regexp, function (view, state, match, start, end) {
        var contentText = match[1];
        var mark = state.schema.marks[name];
        var attrs = getShortcutAttrs(config.handler, view, match, start, end);
        var stashMark = view.state.doc.resolve(start).marks();
        if (!attrs)
            return null;
        var tr = state.tr;
        // add mark and keep the existing mark. The blank is inserted to not apply the 'add mark' to the following input
        tr.delete(start, end).insert(start, [
            state.schema.text(contentText, __spreadArray([mark.create(attrs)], stashMark, true)),
            state.schema.text('\u0020', stashMark),
        ]);
        return tr;
    }, config);
};
export { textMarkShortcut };
//# sourceMappingURL=text-mark-shortcut.js.map